import {simplifyPoints} from '../../util/geometry';
import {ICanvasLine} from '../../incase-domain/proptypes/runfile';

const SIMPLIFY_TOLERANCE_PX = 3;
// Minimum time (ms) between captured samples during an active stroke.
const CAPTURE_THROTTLE_MS = 8;

export function shouldSkipSample(lastCapturedMs: number, nowMs: number): boolean {
    return nowMs - lastCapturedMs < CAPTURE_THROTTLE_MS;
}

export function simplifyCanvasLine(line: ICanvasLine): ICanvasLine {
    if (line.clickX.length <= 2) return line;

    const points = line.clickX.map((x, i) => ({x, y: line.clickY[i]}));
    const simplified = simplifyPoints(points, SIMPLIFY_TOLERANCE_PX, false);

    return {
        clickX: simplified.map((p) => p.x),
        clickY: simplified.map((p) => p.y),
        canvasWidth: line.canvasWidth,
        canvasHeight: line.canvasHeight,
    };
}
